module.exports = __webpack_public_path__ + "static/STORJ-a79054a29479486010f264edb2b10d13.svg";